module.exports = __webpack_public_path__ + "img/Building-Information-Modeling.ecc83424.jpg";